import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { QueryClientProvider } from "@tanstack/react-query";
import { RouterProvider } from "@tanstack/react-router";
import { setUnauthorizedHandler } from "./lib/api";
import { queryClient } from "./lib/queryClient";
import { queryKeys } from "./lib/queries";
import { registerServiceWorker } from "./lib/pwa";
import { applyTheme } from "./lib/theme";
import { browserStorage, sweepRecovery } from "./compose/recovery";
import { router } from "./router";
import { Toasts } from "./ui/Toasts";
import "./styles.css";

applyTheme();
// Unsaved compose text kept for crash recovery: copies past their age are dropped at start.
sweepRecovery(browserStorage());

// A 401 from any mail/account call means the session ended: re-check it; the shell then
// sends the reader to the sign-in page.
setUnauthorizedHandler(() => {
  void queryClient.invalidateQueries({ queryKey: queryKeys.session });
});

// Installable app (production builds only): the worker caches the shell, never /api.
if (import.meta.env.PROD) {
  window.addEventListener("load", () => void registerServiceWorker(), { once: true });
}

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
      <Toasts />
    </QueryClientProvider>
  </StrictMode>,
);
